<template>
    <el-dialog
            :title="changePwdTextConfig.title"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-click-modal="false"
            @close="reset"
            width="700px">

        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item :label="formTextConfig.defaultPwd">
                <el-input :value="formTextConfig.defaultPwdVal" readonly disabled></el-input>
            </el-form-item>
            <el-form-item :label="formTextConfig.newPwd">
                <el-input v-model="form.password" show-password></el-input>
            </el-form-item>
            <el-form-item :label="formTextConfig.confirmPwd" prop="confirmPwd">
                <el-input v-model="form.confirmPwd" show-password></el-input>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{ formTextConfig.cancel }}</el-button>
            <el-button type="primary" @click="changePwd">{{ formTextConfig.ok }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {changePwd} from "@/api/user";

export default {
    props: ['user'],
    data() {
        return {
            dialogVisible: false,
            form: {
                id: null,
                password: undefined,
                confirmPwd: undefined
            },
            rules: {
                confirmPwd: [{
                    validator: (rule, value, callback) => {
                        if (this.form.password !== this.form.confirmPwd) {
                            callback(new Error('两次密码不一致'));
                        } else {
                            callback();
                        }
                    }, trigger: 'blur'
                }]
            }
        }
    },
    computed: {
        changePwdTextConfig() {
            return this.$store.state.global.textConfig.backend.reviewer.button.changePwd
        },
        formTextConfig() {
            return this.changePwdTextConfig.form
        },
    },
    watch: {
        user() {
            this.form = this.user
        }
    },
    methods: {
        open() {
            this.dialogVisible = true
        },
        changePwd() {
            this.$refs.form.validate(vaild => {
                if (vaild) {
                    if (this.form.confirmPwd === undefined || this.form.confirmPwd.length < 1) {
                        this.form.confirmPwd = 'abcd1234'
                        this.form.password = 'abcd1234'
                    }
                    changePwd(this.form.id, this.form).then(res => {
                        if (res.status === 200) {
                            this.$message.success('操作成功')
                            this.dialogVisible = false
                            this.$emit('success')
                        }
                    })
                }
            })
        },
        reset() {
            this.form = {
                id: null,
                password: undefined,
                confirmPwd: undefined
            }
            this.$refs.form.resetFields()
        }
    }
}
</script>

<style scoped>

</style>
